import { Navigate } from 'react-router-dom';

interface PartnerOnlyRouteProps {
  userType: string;
  allowedUserTypes: string[];
  element: React.ReactElement;
  redirectPath?: string;
}

const PartnerOnlyRoute: React.FC<PartnerOnlyRouteProps> = ({
  userType,
  allowedUserTypes,
  element,
  redirectPath = '/',
}) => {
  if (allowedUserTypes.includes(userType)) {
    return element;
  }

  return <Navigate to={redirectPath} replace />;
};

export default PartnerOnlyRoute;
